import { Button } from '@meitu/saas-ui';
import { Editor } from '@meitu/saas-editor-core';
import { traverseTrees } from '@meitu/saas-editor-core/es/utils/tree-kit';
import { ILayerProps } from '@meitu/saas-editor-core/es/version-types';

const ClearMarkBtn: React.FC<{
    editor: Editor;
}> = ({ editor }) => {
    const clearMark = () => {
        const stageIndex = editor.active.getActiveStageIndex();
        const stage = editor.stage.getStageByIndex(stageIndex);
        const extraInfo = editor.stage.getExtraInfo(stageIndex);
        editor.stage.setExtraInfo(stageIndex, { ...extraInfo, extraInfo: undefined });
        traverseTrees(stage, (layer: ILayerProps) => {
            if (layer.extraInfo && layer.extraInfo.label) {
                delete layer.extraInfo.label;
                editor.stage.updateLayer({ ...layer });
            }
        });
    };

    return (
        <div style={{ marginRight: '10px' }}>
            <Button type="primary" data-blue onClick={clearMark}>
                清空打标
            </Button>
        </div>
    );
};

export default ClearMarkBtn;
